import TemplateView from "../../TemplateView";
import messageResource from "../../messageResource";
import Tab from "../../components/Tab";

const TaskManagementScopeFilter = {
    ALL: 'ALL',
    MANAGEMENT_ONLY: 'MANAGEMENT_ONLY'
}

export default class ScopeFilter extends TemplateView {
    constructor({
        onShowOnlyManageableTasksChange = () => {},
    }) {
        super(null)

        this.callbacks = {
            onShowOnlyManageableTasksChange,
        }

        this.state = {
            showOnlyManageableTasks: false
        }

        this._tabsMap = {}

        this.onStatePropertyChanged('showOnlyManageableTasks', showOnlyManageableTasks => {
            this._tabsMap[TaskManagementScopeFilter.ALL].setState({active: !showOnlyManageableTasks})
            this._tabsMap[TaskManagementScopeFilter.MANAGEMENT_ONLY].setState({active: showOnlyManageableTasks})
        })
    }

    templateHtml() {
        return '<div class="taskManagement_scopeFilter components_tabsContainer"></div>'
    }

    afterRender() {
        this._tabsMap[TaskManagementScopeFilter.ALL] = new Tab({
            id: TaskManagementScopeFilter.ALL,
            onClick: () => this.callbacks.onShowOnlyManageableTasksChange(false),
            text: messageResource.getMessage('task.list.header.type_filter.all_tasks'),
        }).init(this.$el)

        this._tabsMap[TaskManagementScopeFilter.MANAGEMENT_ONLY] = new Tab({
            id: TaskManagementScopeFilter.MANAGEMENT_ONLY,
            onClick: () => this.callbacks.onShowOnlyManageableTasksChange(true),
            text: messageResource.getMessage('task.list.header.type_filter.tasks_can_manage'),
        }).init(this.$el)

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/header/ScopeFilter.js